import Dividends from './dividends';

export default Dividends;
